import { Box, Button, createStyles, Theme } from "@material-ui/core";
import DateTimeUtils, { FORMAT_TYPE } from "../../../utils/DateTimeUtils";
import Tooltip from "rc-tooltip";
import React from "react";
import { useTranslation } from "react-i18next";
import OrderRes from "../../../types/res/order/OrderRes";
import styled from "styled-components";
import EnumUtils from "../../../utils/EnumUtils";
import OrderStatus from "../../../types/enum/OrderStatus";
import { useDispatch, useSelector } from "react-redux";
import { cancelOrder } from "redux/actions/order";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import OrderApi from "api/OrderApi";

type Props = {
  order: OrderRes;
  item: any;
  itemContext: any;
  getItemProps: any;
  rightResizeProps: any;
  leftResizeProps: any;
};

const Item = styled.div<{ color: string }>`
  background-color: ${(props) => props.color} !important;
  border: 1px solid ${(props) => props.color} !important;
  border-radius: 4px;
`;
const CastScheduleOrderItem: React.FC<Props> = ({
  order,
  item,
  itemContext,
  getItemProps,
  leftResizeProps,
  rightResizeProps,
}) => {
  const { t } = useTranslation("castSchedule");
  const dispatch = useDispatch();
  const company = useSelector((state) => state.account.staff.company);
  const companyId = useSelector((state) => state.account.staff.companyId);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      button: {
        margin: theme.spacing(1),
      },
    })
  );
  const classes = useStyles();

  const sendEmail = async () => {
    const result = confirm(t("orderItem.sendMailConfirm"));
    if (result) {
      await OrderApi.sendMailCast(companyId, order.orderId);
      alert(t("orderItem.sendMailSuccess"));
    }
  };
  return (
    <Tooltip
      trigger={["hover"]}
      overlayStyle={{ zIndex: "1201" }}
      overlay={
        <Box display="flex" flexDirection="column">
          <span>{t("orderItem.shopLabel")}{order?.shop?.name || t("values.unset")} </span>
          <span>
            {t("orderItem.guestLabel")}{order?.guest?.name || t("values.unset")} ({t("orderItem.hotelInline")}
            {order?.hotel?.name || t("values.unset")})
          </span>
          <span>{t("orderItem.guestTelLabel")}{order?.guest?.tel || t("values.unset")}</span>
          <span>
            {t("orderItem.guestCategoryLabel")}
            {company.guestCategoryShopFlag
              ? order?.guest?.guestGuestCategoryShops?.find(
                  (guestGuestCategoryShop) =>
                    guestGuestCategoryShop.shopId === order.shopId &&
                    guestGuestCategoryShop.guestId === order.guestId
                )?.guestCategory?.name || t("values.unset")
              : order?.guest?.guestCategory?.name || t("values.unset")}
          </span>
          <span>{t("orderItem.castNameLabel")}{order?.castName?.name || t("values.unset")}</span>
          <span>
            {t("orderItem.nominationKindLabel")}
            {order?.nomination?.name || t("values.unset")}
          </span>
          <span>
            {t("orderItem.totalTimeLabel")}{order?.totalTime ? t("orderItem.totalMinutesSuffix", { time: order.totalTime }) : t("values.unset")}
          </span>
          <span>
            {t("orderItem.areaLabel")}
            {order?.area?.name || t("values.unset")}
          </span>
          <span>
            {t("orderItem.hotelLabel")}
            {order?.hotel?.name || t("values.unset")}
          </span>
          <span>
            {t("orderItem.addressLabel")}
            {order?.orderAddress || t("values.unset")}
          </span>
          <span>
            {t("orderItem.address2Label")}
            {order?.orderAddress2 || t("values.unset")}
          </span>
          <span>
            {t("orderItem.optionsLabel")}
            {order?.options?.map((option) => option.name).join("/") || t("values.unset")}
          </span>
          <span>
            {t("orderItem.departureTimeLabel")}
            {order?.departureTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order?.departureTime,
                  FORMAT_TYPE.TIME
                )
              : t("values.unset")}
          </span>
          <span>
            {t("orderItem.planInLabel")}
            {order?.planInTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.planInTime,
                  FORMAT_TYPE.TIME
                )
              : t("values.unset")}
          </span>
          <span>
            {t("orderItem.planOutLabel")}
            {order?.planOutTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.planOutTime,
                  FORMAT_TYPE.TIME
                )
              : t("values.unset")}
          </span>
          <span>
            {t("orderItem.actualInLabel")}
            {order?.actualInTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.actualInTime,
                  FORMAT_TYPE.TIME
                )
              : t("values.unset")}
          </span>
          <span>
            {t("orderItem.actualOutLabel")}
            {order?.actualEndTime
              ? DateTimeUtils.toFormatAsLocalTimezone(
                  order.actualEndTime,
                  FORMAT_TYPE.TIME
                )
              : t("values.unset")}
          </span>
          <span style={{ whiteSpace: "pre-wrap" }}>
            {t("orderItem.memoLabel")}{order?.memo || t("values.unset")}
          </span>
          {EnumUtils.mapToEnum(OrderStatus, order.status) ===
            OrderStatus.hold && (
            <Button
              className={classes.button}
              color="secondary"
              variant="contained"
              onClick={() =>
                dispatch(cancelOrder(companyId, { orderId: order.orderId }))
              }
            >
              {t("orderItem.cancelReservation")}
            </Button>
          )}
          <Button
            className={classes.button}
            color="default"
            variant="contained"
            onClick={sendEmail}
          >
            {t("orderItem.sendMailToCast")}
          </Button>
          <Button
            component={Link}
            to={`/order/${order.orderId}`}
            className={classes.button}
            color="primary"
            variant="contained"
          >
            {t("orderItem.orderDetail")}
          </Button>
        </Box>
      }
    >
      <Item {...getItemProps(item.itemProps)} color={item.color}>
        {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}
        <div
          className="rct-item-content"
          style={{
            maxHeight: `${itemContext.dimensions.height}`,
            color: item.textColor,
            // visit (来店型): title に改行 (\n) が含まれる場合の 2 行表示対応
            whiteSpace: "pre-line",
            lineHeight: 1.2,
            fontSize: "0.9em",
          }}
        >
          {itemContext.title}
        </div>
        <div
          style={{
            height: itemContext.dimensions.height,
            overflow: "hidden",
            paddingLeft: 3,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        />
        {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
      </Item>
    </Tooltip>
  );
};

export default CastScheduleOrderItem;
